import { select } from 'redux-saga/effects';

function* selectMutable(selector) {
  const value = yield select(selector);
  return value && value.toJS ? value.toJS() : value;
}

export default selectMutable;
